<template>
  <div v-if="model">
    <div>
      <l-field :label="t('generate-invoice.tax-id')" mandatory>
        <l-input v-model="model.taxId" />
      </l-field>
      <l-field :label="t('generate-invoice.name')" mandatory>
        <l-input v-model="model.name" />
      </l-field>
    </div>
    <div>
      <l-field :label="t('generate-invoice.address')" mandatory>
        <l-input v-model="model.address" />
      </l-field>
    </div>
  </div>
</template>

<script setup lang="ts">
import { v4 as uuid } from 'uuid'
import { onMounted } from 'vue'
import { useI18n } from 'vue-i18n'

import { LField, LInput } from '@last/core-ui/paprika'

import type { NewCompany } from '@/types'

const cleanCompany: NewCompany = {
  id: uuid()
}

const model = defineModel<NewCompany>()

const { t } = useI18n()

onMounted(() => {
  model.value = {
    ...cleanCompany,
    ...model.value
  }
})
</script>
